import View from './View';
import { withRouter } from 'react-router-dom';

export default withRouter(View);
